module.exports = __webpack_public_path__ + "media/images/web_suite/ap_icon-da7b7f0efb4606e300f586d87ebf28f6.png";